export default __webpack_public_path__ + "static/media/netherland-flag.18bf5c9f.svg";